import { useForm } from 'react-hook-form';

import { TProgramBroadcastForm } from '../types';

export const PROGRAM_BROADCAST_FORM_DEFAULT_VALUES: Partial<TProgramBroadcastForm> = {
  audience_program_source_id: '',
  channel_id: '',
  create_clip: '',
  created_by: '',
  deleted_at: null,
  deleted_by: '',
  delivery_datetime: null,
  description: '',
  dump_program_broadcast_id: '',
  end_datetime: undefined,
  language_id: '',
  language_transcription_id: '',
  name: '',
  parameters: undefined,
  priority: undefined,
  program_classification: '',
  program_id: '',
  program_viewed_place_id: '',
  rebroadcast: '',
  review_state: undefined,
  start_datetime: undefined,
  updated_by: null,
  audience_id: '',
};

export function useProgramBroadcastDrawerFormState() {
  const form = useForm<TProgramBroadcastForm>({
    mode: 'all',
    defaultValues: PROGRAM_BROADCAST_FORM_DEFAULT_VALUES,
  });

  return { form };
}
